// 9fbef606107a605d69c0edbcd8029e5d 
import { ADD_GIFT_CARD_ACTION_PATTERN } from '../../../../../constants/reducer.constants';

const ADD_GIFT_CARD_CONSTANTS = {
  ADD_GIFT_CARD_REQUEST: `${ADD_GIFT_CARD_ACTION_PATTERN}ADD_GIFT_CARD_REQUEST`,
  ADD_GIFT_CARD_FAILED: `${ADD_GIFT_CARD_ACTION_PATTERN}ADD_GIFT_CARD_FAILED`,
  ADD_GIFT_CARD_SUCCESS: `${ADD_GIFT_CARD_ACTION_PATTERN}ADD_GIFT_CARD_SUCCESS`,
  RESET_SHOW_NOTIFICATION: `${ADD_GIFT_CARD_ACTION_PATTERN}RESET_SHOW_NOTIFICATION`,
  ADD_GIFT_CARD_FORM: 'AddGiftCardForm',
};

export default ADD_GIFT_CARD_CONSTANTS;
